import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

/**
 * A component for determining row grid layout
 */
function Row({ className, children }) {
  return <div className={classNames('gel-content-row', className)}>{children}</div>;
}

Row.propTypes = {
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default Row;
